import type { JDSAvatarV2SegmentedRingProps } from './generated/interface';
import React from 'react';

export const withLogic =
  (
    Component: React.ComponentType<JDSAvatarV2SegmentedRingProps>
  ): React.FC<JDSAvatarV2SegmentedRingProps> =>
  (props: JDSAvatarV2SegmentedRingProps) => {
    const defaultRingCount = 4;

    const startAngle = (index: number, len: number): number => {
      if (len === 1) return 0;
      const gap = 5;
      const portion = 360 / len;
      return portion * index + gap;
    };

    const endAngle = (index: number, len: number): number => {
      if (len === 1) return 360;
      const gap = 5;
      const portion = 360 / len;
      return portion * (index + 1) - gap;
    };

    const ring = (
      item: JDSAvatarV2SegmentedRingProps
    ): { startAngle: number; endAngle: number }[] => {
      const rings = [];
      const len = item.count || defaultRingCount;

      for (let index = 0; index < len; index++) {
        rings.push({
          startAngle: startAngle(index, len),
          endAngle: endAngle(index, len)
        });
      }

      return rings;
    };

    return <Component {...{ ...props, _ring: ring(props) }} />;
  };
